import { type BuildTranslationKeys } from '@/types/translation';

import {
  type QuizBankFilterState,
  type QuizBankQuizType,
  type QuizBankSortKey,
} from '../types';

/**
 * 문제 은행 모달 크기. `QuizSetupModal` 의 BANK 단계와 재진입 모달이 함께 쓴다.
 *
 * 높이 재정의는 `tablet-sm` 이상에서만 — 모바일 Drawer 는 제 높이를 스스로 정하므로
 * dvh 고정 높이를 얹으면 주소창 접힘 시 헤더가 잘린다.
 */
export const QUIZ_BANK_MODAL_SIZE_CLASS = [
  'tablet-sm:h-[calc(100dvh-48px)] tablet-sm:max-h-[1100px]',
  'tablet-sm:w-[1600px] tablet-sm:max-w-[calc(100vw-64px)]',
  'tablet-lg:max-w-[calc(100vw-64px)]',
].join(' ');

/** 첫 로딩 스켈레톤 카드 수 */
export const QUIZ_BANK_SKELETON_COUNT = 4;

/** 더 보기 요청 중 목록 끝에 그리는 스켈레톤 수. 표시 전용이고 스크롤 센티넬이 아니다 */
export const QUIZ_BANK_LOAD_MORE_SKELETON_COUNT = 2;

/** 필터 체크리스트 순서 */
export const QUIZ_BANK_QUIZ_TYPES: QuizBankQuizType[] = [
  'multiple',
  'subjective',
  'ox',
];

export const QUIZ_BANK_SORT_TO_SERVER = {
  answerRateDesc: 'CORRECT_RATE_DESC',
  answerRateAsc: 'CORRECT_RATE_ASC',
} as const satisfies Record<QuizBankSortKey, string>;

export const INITIAL_QUIZ_BANK_FILTER_STATE: QuizBankFilterState = {
  gradeId: null,
  unitIds: [],
  types: [],
  query: '',
  sort: 'answerRateDesc',
};

/**
 * 문제 유형 → `build` 로케일 키.
 *
 * 빌드 화면이 이미 쓰는 키(`build.quizType.*`)를 그대로 재사용한다 — 같은
 * 문제 유형을 가리키는데 은행만 다른 키를 쓰면 번역이 따로 놀 수 있다.
 */
export const QUIZ_BANK_QUIZ_TYPE_KEYS = {
  multiple: 'build.quizType.multiple',
  subjective: 'build.quizType.subjective',
  ox: 'build.quizType.ox',
} as const satisfies Record<QuizBankQuizType, BuildTranslationKeys>;

/** 정렬 키 → `build` 로케일 키 */
export const QUIZ_BANK_SORT_KEYS = {
  answerRateDesc: 'quizBank.sort.answerRateDesc',
  answerRateAsc: 'quizBank.sort.answerRateAsc',
} as const satisfies Record<QuizBankSortKey, BuildTranslationKeys>;
